import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/new_logo.png';
import './Logo.css';

function Logo() {
  return (
    <Link to="/home" className="logo">
      <img src={logoImage} alt="Logo" className="logo-img" />
    </Link>
  );
}

export default Logo;
